import { Stack } from '@mui/material';
// import { useEffect } from 'react';
import { ReportsProjectFilter } from 'src/@types/project';
import { Range } from 'src/components/date-range-picker';
import { Teammate } from 'src/@types/teammates';
import { ReportsGeographyFilter } from 'src/@types/geographyFilters';
import { ReportsTeamFilter } from 'src/@types/team';
import { TOutreachType } from 'src/@types/outreachType';
import ActivityFeed from 'src/sections/main/reports/ActivityFeed';
import Scrollbar from 'src/components/scrollbar';
import ReportsFiltersChips from 'src/sections/main/reports/ReportsFiltersChips';

// ----------------------------------------------------------------------

type Props = {
  setFilteredUser: (user: Teammate | Partial<Teammate> | null) => void;
  filteredUser: Teammate | Partial<Teammate> | null;
  setFilteredProject: (project: ReportsProjectFilter | null) => void;
  filteredProject: ReportsProjectFilter | null;
  setFilteredDateRange: (daterange: Range | null) => void;
  filteredDateRange: Range | null;
  setFilteredCounty: (county: ReportsGeographyFilter | null) => void;
  filteredCounty: ReportsGeographyFilter | null;
  setFilteredPrecinct: (precinct: ReportsGeographyFilter | null) => void;
  filteredPrecinct: ReportsGeographyFilter | null;
  setFilteredCongressionalDistrict: (congressionalDistrict: ReportsGeographyFilter | null) => void;
  filteredCongressionalDistrict: ReportsGeographyFilter | null;
  setFilteredStateHouseDistrict: (stateHouseDistrict: ReportsGeographyFilter | null) => void;
  filteredStateHouseDistrict: ReportsGeographyFilter | null;
  setFilteredStateSenateDistrict: (stateSenateDistrict: ReportsGeographyFilter | null) => void;
  filteredStateSenateDistrict: ReportsGeographyFilter | null;
  setFilteredDma: (dma: ReportsGeographyFilter | null) => void;
  filteredDma: ReportsGeographyFilter | null;
  setFilteredTeam: (team: ReportsTeamFilter | null) => void;
  filteredTeam: ReportsTeamFilter | null;
  setFilteredOutreachType?: (outreachType: TOutreachType | null) => void | null;
  filteredOutreachType?: TOutreachType | null;
};

export default function HeadlessActivityFeed({
  setFilteredUser,
  filteredUser,
  setFilteredProject,
  filteredProject,
  setFilteredDateRange,
  filteredDateRange,
  setFilteredCounty,
  filteredCounty,
  setFilteredPrecinct,
  filteredPrecinct,
  setFilteredCongressionalDistrict,
  filteredCongressionalDistrict,
  setFilteredStateHouseDistrict,
  filteredStateHouseDistrict,
  setFilteredStateSenateDistrict,
  filteredStateSenateDistrict,
  setFilteredDma,
  filteredDma,
  setFilteredTeam,
  filteredTeam,
  setFilteredOutreachType,
  filteredOutreachType,
}: Props) {
  return (
    <>
      {
        <>
          {(filteredUser ||
            filteredProject ||
            filteredDateRange ||
            filteredCounty ||
            filteredPrecinct ||
            filteredCongressionalDistrict ||
            filteredStateHouseDistrict ||
            filteredStateSenateDistrict ||
            filteredDma ||
            filteredTeam ||
            filteredOutreachType) && (
            <Stack paddingLeft={2.5} paddingRight={1} paddingY={0.5}>
              <ReportsFiltersChips
                setFilteredUser={setFilteredUser}
                filteredUser={filteredUser}
                setFilteredProject={setFilteredProject}
                filteredProject={filteredProject}
                setFilteredDateRange={setFilteredDateRange}
                filteredDateRange={filteredDateRange}
                setFilteredCounty={setFilteredCounty}
                filteredCounty={filteredCounty}
                setFilteredPrecinct={setFilteredPrecinct}
                filteredPrecinct={filteredPrecinct}
                setFilteredCongressionalDistrict={setFilteredCongressionalDistrict}
                filteredCongressionalDistrict={filteredCongressionalDistrict}
                setFilteredStateHouseDistrict={setFilteredStateHouseDistrict}
                filteredStateHouseDistrict={filteredStateHouseDistrict}
                setFilteredStateSenateDistrict={setFilteredStateSenateDistrict}
                filteredStateSenateDistrict={filteredStateSenateDistrict}
                setFilteredDma={setFilteredDma}
                filteredDma={filteredDma}
                setFilteredTeam={setFilteredTeam}
                filteredTeam={filteredTeam}
                setFilteredOutreachType={setFilteredOutreachType}
                filteredOutreachType={filteredOutreachType}
              />
            </Stack>
          )}
          <Scrollbar>
            <Stack paddingLeft={2.5} paddingRight={1} paddingY={2.5}>
              <ActivityFeed
                filteredOutreachType={filteredOutreachType}
                filteredUser={filteredUser}
                filteredProject={filteredProject}
                filteredDateRange={filteredDateRange}
                filteredCounty={filteredCounty}
                filteredPrecinct={filteredPrecinct}
                filteredCongressionalDistrict={filteredCongressionalDistrict}
                filteredStateHouseDistrict={filteredStateHouseDistrict}
                filteredStateSenateDistrict={filteredStateSenateDistrict}
                filteredDma={filteredDma}
                filteredTeam={filteredTeam}
                config={{
                  refetchOnMount: true,
                }}
              />
            </Stack>
          </Scrollbar>
        </>
      }
    </>
  );
}
